<template>
  <v-dialog
    v-model="config.status.active"
    max-width="600">
    <v-form lazy-validation ref="form" v-model="form.valid">
      <v-card>
        <v-card-title class="pt-0">
          <v-row dense>
            <v-col cols="12">
              <v-combobox hide-details multiple small-chips
                v-model="form.sendTo"
                ref="sendto"
                prefix="宛先"
                :items="getContactItems"
                :rules="rules.email"
                :loading="isSearching"
                :search-input.sync="form.search"
                :append-icon="null"
                @change="resetSearch"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field hide-details
                v-model="form.subject"
                prefix="件名"
              />
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <v-textarea
            v-model="form.body"
            placeholder="本文"
          />
          <v-list dense>
            <v-list-item v-for="item in getAttachmentItems" :key="item.id">
              <v-list-item-avatar>
                <v-icon small :class="item.iconColor">{{ item.icon }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row dense align="center">
                  <v-col cols="9">{{ item.name }}</v-col>
                  <v-col cols="3">
                    <v-select hide-details outlined dense
                      v-model="item.expire.number"
                      label="有効期限"
                      suffix="日間"
                      :append-icon="null"
                      :items="meta.numbers"
                    />
                  </v-col>
                </v-row>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon color="red" @click="removeAttachment(item)">
                  <v-icon small>fal fa-trash-alt</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text
            color="secondary"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon
                v-on="on"
                color="secondary"
                class="mr-2"
                :disabled="!getClientId"
                @click.stop="openFiler">
                <v-icon small>fal fa-paperclip</v-icon>
              </v-btn>
            </template>
            <span>ファイルを添付する</span>
          </v-tooltip>
          <v-btn depressed
            color="secondary"
            :loading="isLoading"
            :disabled="!isValid"
            @click="sendEmail"><v-icon small class="mr-2">fal fa-paper-plane</v-icon>送信する</v-btn>
        </v-card-actions>
        <v-dialog scrollable v-model="config.filer.active" max-width="800">
          <v-card class="px-0" width="100%">
            <v-card-text class="px-0">
              <Filer v-if="config.filer.active"
                :rid="getRootMediaId"
                :cid="getClientId"
                :fixedRoot="true"
                :filters="{ ids: getAttachmentIds }"
                @select="selectAttachments"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click.stop="closeFiler">閉じる</v-btn>
              <v-spacer></v-spacer>
              <v-btn depressed color="secondary" :disabled="!store.attachments.length" @click.stop="attachFiles">選択する</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import _ from 'lodash'
import Filer from '@/components/filers/client'
const FILES = {
  FILE: {
    icon: 'fa-file',
    color: 'gray--text text--darken-2'
  },
  DOC: {
    icon: 'fa-file-word',
    color: 'blue--text text--darken-3'
  },
  DOCX: {
    icon: 'fa-file-word',
    color: 'blue--text text--darken-3'
  },
  XLS: {
    icon: 'fa-file-excel',
    color: 'green--text text--darken-3'
  },
  XLSX: {
    icon: 'fa-file-excel',
    color: 'green--text text--darken-3'
  },
  PPT: {
    icon: 'fa-file-powerpoint',
    color: 'orange--text text--darken-3'
  },
  PPTX: {
    icon: 'fa-file-powerpoint',
    color: 'orange--text text--darken-3'
  },
  PDF: {
    icon: 'fa-file-pdf',
    color: 'red--text text--darken-3'
  },
  PNG: {
    icon: 'fa-file-image',
    color: 'grey--text text--darken-4'
  },
  JPG: {
    icon: 'fa-file-image',
    color: 'grey--text text--darken-4'
  },
  JPEG: {
    icon: 'fa-file-image',
    color: 'grey--text text--darken-4'
  },
  BMP: {
    icon: 'fa-file-image',
    color: 'grey--text text--darken-4'
  },
  GIF: {
    icon: 'fa-file-image',
    color: 'grey--text text--darken-4'
  },
  TXT: {
    icon: 'fa-file-alt',
    color: 'blue-grey--text text--darken-1'
  },
  MD: {
    icon: 'fa-file-invoice',
    color: 'blue-grey--text text--darken-1'
  },
  ZIP: {
    icon: 'fa-file-archive',
    color: 'brown--text'
  },
  EML: {
    icon: 'fa-envelope',
    color: 'blue--text text--darken-1'
  }
}
export default {
  name: 'mailer',
  components: {
    Filer
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        },
        filer: {
          active: false
        }
      },
      meta: {
        numbers: new Array(100).fill(null).map((_, i) => (i + 1)),
      },
      store: {
        attachments: [],
        contacts: []
      },
      form: {
        valid: true,
        search: '',
        sendTo: [],
        subject: '',
        body: '',
        attachments: []
      },
      rules: {
        email: [
          v => !!v || '必須項目です',
          vs => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return vs.filter(v => { return !pattern.test(v.value || v) }).length === 0 || '妥当なEメールではありません。'
          }
        ]
      }
    }
  },
  methods: {
    sendEmail: function () {
      this.$refs.sendto.blur()
      this.$nextTick(() => {
        this.submit({ type: 'send' })
      })
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { sendTo, subject, body, attachments, search } = this.form
      const sendFrom = this.$store.getters['author/getAll']()
      const cid = this.$route.params.id || this.form.cid
      const developer = this.$store.getters['author/get']('roles').includes('developer')
      const urls = {
        send: `${this.$url.api}mail/send/email`,
        contact: `${this.$url.api}mail/get/contacts`
      }
      const fds = {
        send: { sendTo, sendFrom, subject, body, attachments },
        contact: { address: search }
      }
      if (type && urls[type] && fds[type]) {
        if (type === 'send' && this.$refs.form.validate()) {
          const url = urls[type]
          const fd = fds[type]
          this.$set(this.config.status, 'loading', true)
          return { url, fd, type }
        } else if (type === 'contact' && search) {
          const url = urls[type]
          const fd = fds[type]
          this.$set(this.config.status, 'searching', true)
          return { url, fd, type }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, postType) {
      if (postType === 'send') {
        this.$set(this.config.status, 'loading', false)
        this.close()
      } else if (postType === 'contact') {
        this.$set(this.store, 'contacts', req)
        this.$set(this.config.status, 'searching', false)
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
      this.$set(this.config.status, 'searching', false)
    },
    open: function (req) {
      const { title, content, attachments } = req
      this.$set(this, 'form', {
        valid: true,
        search: '',
        sendTo: [],
        subject: title || '',
        body: content || '',
        attachments: []
      })
      this.$set(this, 'store', {
        attachments: [],
        contacts: []
      })
      for (let i = 0; i < attachments.length; i++) {
        this.addAttachment(attachments[i])
      }
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    searchContacts: _.debounce(function (val) {
      this.submit({ type: 'contact' })
    }, 300),
    resetSearch: function () {
      this.$set(this.form, 'search', '')
    },
    addAttachment: function (req) {
      const { id } = req
      this.form.attachments.push(Object.assign({}, req, {
        expire: {
          number: 7,
          unit: 'd'
        }
      }))
    },
    removeAttachment: function (req) {
      const { id } = req
      const idx = this.form.attachments.findIndex(it => { return it.id === id })
      if (idx >= 0) {
        this.form.attachments.splice(idx, 1)
      }
    },
    attachFiles: function () {
      const { attachments } = this.store
      for (let i = 0; i < attachments.length; i++) {
        this.addAttachment(attachments[i])
      }
      this.closeFiler()
    },
    openFiler: function () {
      this.$set(this.config.filer, 'active', true)
    },
    closeFiler: function () {
      this.$set(this.config.filer, 'active', false)
      this.$set(this.store, 'attachments', [])
    },
    selectAttachments: function (items) {
      const selects = items ? items.filter(it => {
        const { id, type } = it
        return (id && type && type !== 'folder')
      }) : []
      this.$set(this.store, 'attachments', selects)
    }
  },
  watch: {
    'form.search': function (newVal, oldVal) {
      if (newVal && oldVal && newVal.length < oldVal.length) {
        this.$set(this.store, 'contacts', [])
      }
      if (!this.config.status.searching) {
        this.searchContacts()
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    getAttachmentItems () {
      return this.form.attachments && this.form.attachments.length ? this.form.attachments.map(it => {
        const extension = it.extension || it.name.split('.').pop()
        const iconMeta = FILES[extension ? extension.toUpperCase() : '-'] || FILES.FILE
        return Object.assign({}, it, {
          icon: `fas ${iconMeta.icon}`,
          iconColor: iconMeta.color
        })
      }) : []
    },
    getAttachmentIds () {
      return this.form.attachments.length ? this.form.attachments.map(it => {
        return `${it.id}`
      }) : []
    },
    getRootMediaId () {
      return this.$store.getters['client/get']('lib').media
    },
    getClientId () {
      return this.$route.params.id || this.form.cid
    },
    getContactItems () {
      return this.store.contacts.length ? this.store.contacts.map(it => {
        return {
          text: `${it.name.replace(',', '')} <${it.contact}>`,
          value: it.contact
        }
      }) : []
    }
  }
}
</script>